import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';

import { ProductsComponent } from './products.component';
import { ProductsRoutingModule } from './products-routing.module';
import { ProductsListComponent } from './products/products.component';
import { ProductDetailComponent } from './product-detail/product-detail.component';
import { DataViewModule } from 'primeng/dataview';
import { ButtonModule } from 'primeng/button';
import { DropdownModule } from 'primeng/dropdown';
import { InputTextModule } from 'primeng/inputtext';
import { RippleModule } from 'primeng/ripple';
import { InputNumberModule } from 'primeng/inputnumber';
import { CarouselModule } from 'primeng/carousel';
import { SkeletonModule } from 'primeng/skeleton';
import { TableModule } from 'primeng/table';
import { CardModule } from 'primeng/card';
import { NbButtonModule, NbCardModule, NbDialogModule, NbInputModule } from '@nebular/theme';
import { CustomInputNumberModule } from '../../shared/custom-input-number/custom-input-number.module';
import { DialogPriceChangedComponent } from './dialog-price-changed/dialog-price-changed.component';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { ProductGridModule } from 'app/shared/product-grid/product-grid.module';
import { DialogProductImagesComponent } from './dialog-product-images/dialog-product-images.component';
import { OnlyNumbersDirective } from './only-number.directive';
import { ComponentsModule } from 'app/component/components.module';

@NgModule({
  declarations: [
    ProductsComponent,
    ProductsListComponent,
    ProductDetailComponent,
    DialogPriceChangedComponent,
    DialogProductImagesComponent,
    OnlyNumbersDirective,
  ],
  imports: [
    CommonModule,
    ProductsRoutingModule,
    DataViewModule,
    NbCardModule,
    InputTextModule,
    NbDialogModule,
    DropdownModule,
    NbInputModule,
    NbButtonModule,
    ButtonModule,
    RippleModule,
    FormsModule,
    CarouselModule,
    SkeletonModule,
    TableModule,
    InputNumberModule,
    CardModule,
    CustomInputNumberModule,
    ProgressSpinnerModule,
    ProductGridModule,
    ComponentsModule,
  ],
})
export class ProductsModule { }
